import { useCategoriesStore } from '@src/pinia/categories'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

export default function useCategories() {
  const categoriesStore = useCategoriesStore()
  const {
    categories, categoriesTranslated
  } = storeToRefs(categoriesStore)

  const { loadCategories } = categoriesStore

  onMounted(() => {
    loadCategories(false)
  })

  function refreshCategories() {
    loadCategories(true)
  }

  return {
    categories,
    categoriesTranslated,
    refreshCategories,
    loadCategories
  }
}
